import { emptyCharacter } from "@/generic/config";
import { Text as NativeText, TextProps } from "@chakra-ui/react"

const Text = ({
    children,
    variant = "normal",
    style = "normal",
    weight,
    ...rest
}: {
    children?: any,
    variant?: "normal" | "title" | "subtitle" | "small" | "extra-small",
    style?: "normal" | "italic" | "oblique",
    weight?: TextProps["fontWeight"],
} & TextProps) => {
    let fontSize: TextProps["fontSize"] = "medium";
    let fontWeight: TextProps["fontWeight"] = "normal";
    let letterSpacing: string | undefined = undefined;

    // If adding new variants, ensure they are defined in the theme tokens
    switch (variant) {
        case "title":
            fontWeight = "600";
            fontSize = "larger";
            letterSpacing = "-0.025em";
            break;
        case "subtitle":
            fontWeight = "500";
            fontSize = "large";
            letterSpacing = "-0.01em";
            break;
        case "small":
            fontSize = "small";
            break;
        case "extra-small":
            fontSize = "x-small";
            break;

        // Default case
        case "normal":
            fontSize = "medium";
            break;
        default:
            fontSize = "medium";
            break;
    }

    const content = typeof children === "number" ?
        children.toString() :
        typeof children === "string" ?
            (children || emptyCharacter) :
            children;


    return (
        <NativeText fontWeight={weight ?? fontWeight} fontSize={fontSize} fontStyle={style} letterSpacing={letterSpacing} {...rest}>
            {content}
        </NativeText>
    )
}

export default Text;